import { api } from "./api";

export const studentAttendanceList = async (addUrl = "") => {
  return await api.get(`/all/student/attendance/list?${addUrl}`);
};

export const studentAttendanceListMonthly = async (addUrl = "") => {
  return await api.get(`/all/student/attendance/list/monthly?${addUrl}`);
};
export const studentAttendanceListAnnual = async (addUrl = "") => {
  return await api.get(`/all/student/attendance/annual?${addUrl}`);
};
export const studentAttendanceListMonthlyV4 = async (addUrl = "") => {
  return await api.get(`/all/student/attendance/list/monthly/v4?${addUrl}`);
};

export const studentAttendanceListAnnualV4 = async (addUrl = "") => {
  return await api.get(`/all/student/attendance/annual/v4?${addUrl}`);
};

export const studentAttendanceDashboard = async (addUrl = "") => {
  return await api.get(`/student/attendance/dashboard?${addUrl}`);
};

export const studentAttendanceDashboardV4 = async (addUrl = "") => {
  return await api.get(`/student/attendance/dashboard/overview/v4?${addUrl}`);
};
export const studentAttendanceDashboard2V4 = async (addUrl = "") => {
  return await api.get(`/student/attendance/dashboard/details/v4?${addUrl}`);
};

export const studentAttendanceRangeSummary = async (addUrl = "") => {
  return await api.get(`/student/attendance/range/summary?${addUrl}`);
};

export const studentAttendancePost = async (data) => {
  return await api.post(`/student/attendance/post`, data);
};

export const studentAttendanceBatchPost = async (data) => {
  return await api.post(`/students/attendances/post`, data);
};

export const studentAttendanceBatchMarkPost = async (data) => {
  return await api.post(`/students/attendances/mark/post`, data);
};

export const studentAttendanceSendMessage = async (addUrl = ``) => {
  return await api.get(`/student/attendance/send/message?${addUrl}`);
};

export const studentAttendancePresentSendMessage = async (addUrl = ``) => {
  return await api.get(`/present/student/attendance/send/message?${addUrl}`);
};

export const studentAttendanceAbsentSendMessage = async (addUrl = ``) => {
  return await api.get(`/absent/student/attendance/send/message?${addUrl}`);
};

export const studentAttendanceFailedSendMessage = async (addUrl = ``) => {
  return await api.get(`/student/attendance/send/failed/message?${addUrl}`);
};

export const studentAttendancePresentFailedSendMessage = async (addUrl = ``) => {
  return await api.get(`/present/student/attendance/send/failed/message?${addUrl}`);
};

export const studentAttendanceAbsentFailedSendMessage = async (addUrl = ``) => {
  return await api.get(`/absent/student/attendance/send/failed/message?${addUrl}`);
};


export const staffAttendanceList = async (addUrl = "") => {
  return await api.get(`/all/staff/attendance/list?${addUrl}`);
};

export const staffAttendanceListMonthly = async (addUrl = "") => {
  return await api.get(`/all/staff/attendance/list/monthly?${addUrl}`);
};
export const staffAttendanceDashboard = async (addUrl = "") => {
  return await api.get(`/staff/attendance/dashboard?${addUrl}`);
};
export const staffLowAttendanceData = async (addUrl = "") => {
  return await api.get(`/staff/low/attendance?${addUrl}`);
};

export const staffAttendancePost = async (data) => {
  return await api.post(`/staff/attendance/post`, data);
};

export const staffAttendanceSendMessage = async (addUrl = ``) => {
  return await api.get(`/staff/attendance/send/message?${addUrl}`);
};

export const staffAttendanceAbsentSendMessage = async (addUrl = ``) => {
  return await api.get(`/absent/staff/attendance/send/message?${addUrl}`);
};


export const studentAttendanceResetTodayMessageLogs = async (addUrl = "") => {
  return await api.get(`/attendance/reset/today/message/logs?${addUrl}`);
};

export const studentManualAttendancePost = async (data) => {
  return await api.post(`/student/attendance/manual/post`, data);
};

export const studentLowAttendanceLongAbsentReport = (addUrl = "") => {
  return api.get(
    `/student-attendance/low-attendance-long-absent-report?${addUrl}`
  );
};

export const studentAttendanceFullReport = (studentId, addUrl = "") => {
  return api.get(
    `/student-attendance/student/${studentId}/full-report${addUrl ? `?${addUrl}` : ""}`
  );
};


export const studentAttendanceStudentSearch = (addUrl = "") => {
  return api.get(
    `/student-attendance/search-students${
      addUrl ? `?${addUrl.replace(/^&/, "")}` : ""
    }`
  );
};

export const studentsLongAbsentList = (params = "") => {
  return api.get(
    `/student/attendance/long-absent-list${
      params ? `?${params}` : ""
    }`
  );
};

export const addAttendanceFollowup = (payload) => {
  return api.post("/followup/add", payload);
};

export const getAttendanceFollowupHistory = (studentId) => {
  return api.get("/followups", {
    params: {
      student_id: studentId,
      type: "attendance",
    },
  });
};

// export const addAttendanceFollowup = (payload) =>
//   Api.post("/attendance/followups", payload);